import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DprDashboardTableProps = {
  topHeader: string[];
  header: string[];
  data: any;
};

export function DprDashboardTable({
  data,
  header,
  topHeader,
}: DprDashboardTableProps) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell
                align="center"
                {...styles("cell")}
                key={index}
                colSpan={2}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {header.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell align="center" {...styles("cell")}>
                {row.sno}
              </TableCell>
              <TableCell
                align="center"
                {...styles("cell", { minWidth: "100px", padding: "5px" })}
              >
                {row.state}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberAllDpr}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaAllDpr}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberDprUnderDno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaDprUnderDno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberQueryFromDno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaQueryFromDno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberDprUnderSno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaDprUnderSno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberQueryFromSno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaQueryFromSno}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberDprUnderAdmin}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaDprUnderAdmin}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberQueryFromAdmin}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaQueryFromAdmin}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberDprApproved}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaDprApproved}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberDprRejected}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaDprRejected}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
